// orderEditReducer.js
import {
  ADD_TO_ORDER,
  REMOVE_FROM_ORDER,
  UPDATE_ORDER_ITEM_QUANTITY,
  UPDATE_ORDER_ITEM,
  UPDATE_ORDER_ITEM_DISCOUNT,
  DOWNGRADE_ORDER_ITEM_QUANTITY,
  UPDATE_ORDER_ITEM_VOID,
  UPDATE_ORDER_ITEM_REFUND,
  SET_ORDER_DATA,
  UPDATE_ORDER_ITEM_INSTRUCTIONS,
  CLEAR_ORDER,
} from '../actions/types';

const initialState = {
  items: [],
};

const orderEditReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_ORDER:
      const newIndex = state.items.length;
      const newItem = {
        ...action.payload,
        index: newIndex,
        void: false,
        refund: false,
        quantity: action.payload.quantity || 1,
      };
      return {
        ...state,
        items: [...state.items, newItem],
      };

    case REMOVE_FROM_ORDER:
      return {
        ...state,
        items: state.items.filter((item, i) => {
          // Check if we're removing by index and itemData match
          if (action.payload.index !== undefined) {
            const itemId = item.itemData?.id || item.itemData?.itemId;
            const payloadItemId = action.payload.itemData?.itemData?.id || action.payload.itemData?.itemData?.itemId;
            return !(i === action.payload.index && itemId === payloadItemId);
          }
          // Fallback to itemId only
          return item.itemData?.id !== action.payload.itemData?.id;
        }),
      };

    case UPDATE_ORDER_ITEM:
      return {
        ...state,
        items: state.items.map((item, index) => {
          if (index === action.payload.index) {
            return {
              ...item,
              itemData: {
                ...item.itemData,
                ...action.payload.updates,
              },
            };
          }
          return item;
        }),
      };

    case UPDATE_ORDER_ITEM_VOID:
      return {
        ...state,
        items: state.items.map((item, index) => {
          if (index === action.payload.index) {
            return {
              ...item,
              void: action.payload.voidStatus,
              // Reset refund if unvoiding
              refund: action.payload.voidStatus ? item.refund : false,
            };
          }
          return item;
        }),
      };

    case UPDATE_ORDER_ITEM_REFUND:
      return {
        ...state,
        items: state.items.map((item, index) => {
          if (index === action.payload.index) {
            return {
              ...item,
              refund: action.payload.refundStatus,
            };
          }
          return item;
        }),
      };

    case UPDATE_ORDER_ITEM_QUANTITY:
      return {
        ...state,
        items: state.items.map((item, index) => {
          if (index === action.payload.index) {
            return {
              ...item,
              quantity: Math.max(1, item.quantity + 1),
            };
          }
          return item;
        }),
      };

    case DOWNGRADE_ORDER_ITEM_QUANTITY:
      return {
        ...state,
        items: state.items.map((item, index) => {
          if (index === action.payload.index && item.quantity > 1) {
            return {
              ...item,
              quantity: item.quantity - 1,
            };
          }
          return item;
        }),
      };

    case UPDATE_ORDER_ITEM_DISCOUNT:
      return {
        ...state,
        items: state.items.map((item, index) => {
          if (index === action.payload.index) {
            return {
              ...item,
              itemData: {
                ...item.itemData,
                menuItemDiscount: action.payload.discount,
                selectedPromotionDetails: action.payload.selectedPromotionDetails,
                discountType: action.payload.discountType,
                discountId: action.payload.discountId,
                promotionId: action.payload.promotionId,
              },
            };
          }
          return item;
        }),
      };

    case UPDATE_ORDER_ITEM_INSTRUCTIONS:
      return {
        ...state,
        items: state.items.map((item, index) => {
          if (index === action.payload.index) {
            return {
              ...item,
              specialInstructions: action.payload.instructions,
            };
          }
          return item;
        }),
      };

    case SET_ORDER_DATA:
      return {
        ...state,
        items: action.payload.map((item, index) => ({
          ...item,
          index: index,
          void: item.void || item.itemData?.voidItem || false,
          refund: item.refund || item.itemData?.refunded || false,
        })),
      };

    case CLEAR_ORDER:
      return {
        ...state,
        items: [],
      };

    default:
      return state;
  }
};

export default orderEditReducer;
